import { Component, inject, OnInit } from '@angular/core';
import { BreadcrumbService } from '../../services';
import { Breadcrumb } from '../../types/breadcrumb';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { UnsubscribeOnDestroy } from '../../classes';
import { takeUntil } from 'rxjs';

@Component({
	selector: 'breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss'],
	standalone: true,
	imports: [NgTemplateOutlet, RouterLink]
})
export class BreadcrumbComponent extends UnsubscribeOnDestroy implements OnInit {
	private service = inject(BreadcrumbService);
	breadcrumbs: Breadcrumb[] = [];
	previous: Breadcrumb = null;
	hideBreadcrumb: boolean = false;

	constructor() {
		super();
		this.service.breadcrumbs
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe((value) => {
				this.breadcrumbs = value;

				const clickable = this.breadcrumbs.filter((bc) => bc.clickable);
				this.previous = clickable.length > 0 ? clickable[clickable.length - 1] : null;
			});

		this.service.hideBreadcrumbComponent
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe((value) => {
				this.hideBreadcrumb = value;
			});
	}

	ngOnInit() {
	}

}

